import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService,
MesVaccinService
 } from '../../../../../services'

import { MesVaccinsAssociateComponent } from '../../../../partials/layout/dialogs/mesvaccins-associate-dialog/mesvaccins-associate.component'


import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'dossier-mesvaccins'

@Component({
  selector: 'atyl-dossier-mesvaccins',
  templateUrl: './dossier-mesvaccins.component.html',
  styleUrls: ['./dossier-mesvaccins.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-mesvaccins',
  key: KEY,
})
export class DossierMesVaccinsComponent implements OnInit {

  @Input() loading:BehaviorSubject<any>=new BehaviorSubject<any>(null);
  
  @StringableValues(KEY) strings: any
  
  @Input() dossier: any;

  activeButton:boolean=false;

  forms:any[]=[];

  code_ID:string="MV_ID";
  code_UIID:string="MV_UUID";
  

  associateButton:boolean=true;

  

  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private changeDetectorRef: ChangeDetectorRef,
     private mesVaccinsService: MesVaccinService
  ) { }

  ngOnInit() {
	  
	  this.loading.subscribe((dossier)=>{
			  if (dossier) {
				  console.log("personne dossier change ",dossier);
				this.dossier=dossier;
				this.loadForm();
				}
		 });
	  
	 	
      this.loadForm();
    
  }
  
   loadForm() {
	   console.log(" DossierMesVaccinsComponentdossier ",this.dossier);	
	   
	   this.associateButton= !(this.dossier.donnees
	   && this.dossier.donnees[this.code_ID]!=undefined
	  /* && this.dossier.donnees[this.code_UIID]!=undefined*/
	   );
	   	
   }
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
   	associate(event:any) {
	    this.dialogService.open(MesVaccinsAssociateComponent, {
            data: {
               
                dossier: this.dossier,
                
            },
            draggable: false,
            resizable: false,
        })
	   
    }
   
   colibri(event:any) {
	   let _ops={
		       
		}
	   this.mesVaccinsService.url(this.dossier.ID).subscribe(
			(res: JSONRpcResponse) => {
				console.log("DossierMesVaccinsComponent colibri",this.dossier.ID,res);
				if (res.result 
					&& res.result!=undefined
				)
					window.open(res.result, ' _blank');
			}
		);
   }
   
    document(event:any,type:string) {
	 /*let _ops={
		       
		}
		_ops[type]=true;*/
		this.mesVaccinsService.url(this.dossier.ID,type).subscribe(
			(res: JSONRpcResponse) => {
				console.log("DossierMesVaccinsComponent document",this.dossier.ID,type,res);
				if (res.result 
				&& res.result!=undefined
				)
				window.open(res.result, ' _blank');
			}
		);		
			
   }

}
